import { useEffect } from "react";
import { StageCanvas } from "@/components/StageCanvas";
import { SceneHost } from "@/components/SceneHost";
import { HudLayer } from "@/hud/HudLayer";
import { ToastRail } from "@/components/ToastRail";
import { StoryFlashOverlay } from "@/components/StoryFlashOverlay";
import { MasteryCutsceneOverlay } from "@/components/MasteryCutsceneOverlay";
import { SituationDrawer } from "@/components/SituationDrawer";
import { OrientationGuard } from "@/components/OrientationGuard";
import { CheatGate } from "@/components/CheatPanel";
import { useSceneStore } from "@/engine/SceneManager";
import { useSession } from "@/state/session";
import { useAffinity } from "@/state/affinity";

const loadSplashScene = () => import("@/scenes/Splash/SplashScene").then(m => m.SplashScene);
const loadHomeScene = () => import("@/scenes/Home/HomeScene").then(m => m.HomeScene);
const loadRunForgeScene = () => import("@/scenes/RunForge/RunForgeScene").then(m => m.RunForgeScene);
const loadWeeklyTurnScene = () => import("@/scenes/WeeklyTurn/WeeklyTurnScene").then(m => m.WeeklyTurnScene);
const loadEventScene = () => import("@/scenes/Event/EventScene").then(m => m.EventScene);
const loadCharacterSheetScene = () => import("@/scenes/CharacterSheet/CharacterSheetScene").then(m => m.CharacterSheetScene);
const loadRunResultScene = () => import("@/scenes/RunResult/RunResultScene").then(m => m.RunResultScene);
const loadSettingsScene = () => import("@/scenes/Settings/SettingsScene").then(m => m.SettingsScene);
const loadShopScene = () => import("@/scenes/Shop/ShopScene").then(m => m.ShopScene);
const loadCombatScene = () => import("@/scenes/Combat/CombatScene").then(m => m.CombatScene);
const loadTacticEditorScene = () => import("@/scenes/TacticEditor/TacticEditorScene").then(m => m.TacticEditorScene);
const loadAdminScene = () => import("@/scenes/Admin/AdminScene").then(m => m.AdminScene);
const loadEncyclopediaScene = () => import("@/scenes/Encyclopedia/EncyclopediaScene").then(m => m.EncyclopediaScene);

/**
 * 앱 셸. 씬 레지스트리 초기화 + 세션 부트스트랩 + HUD·ToastRail 오버레이.
 */
export default function App() {
    const registerScenes = useSceneStore(s => s.registerScenes);
    const reset = useSceneStore(s => s.reset);
    const bootstrap = useSession(s => s.bootstrap);
    const affinityBootstrap = useAffinity(s => s.bootstrap);

    useEffect(() => {
        bootstrap();
        affinityBootstrap();
        registerScenes([
            ["splash",           { load: loadSplashScene } as never],
            ["home",             { load: loadHomeScene } as never],
            ["run-forge",        { load: loadRunForgeScene } as never],
            ["weekly-turn",      { load: loadWeeklyTurnScene } as never],
            ["event",            { load: loadEventScene } as never],
            ["character-sheet",  { load: loadCharacterSheetScene } as never],
            ["run-result",       { load: loadRunResultScene } as never],
            ["settings",         { load: loadSettingsScene } as never],
            ["shop",             { load: loadShopScene } as never],
            ["combat",           { load: loadCombatScene } as never],
            ["tactic-editor",    { load: loadTacticEditorScene } as never],
            ["admin",            { load: loadAdminScene } as never],
            ["encyclopedia",     { load: loadEncyclopediaScene } as never],
        ]);
        void reset("splash");
    }, [bootstrap, affinityBootstrap, registerScenes, reset]);

    return (
        <>
            <StageCanvas>
                <SceneHost />
                <HudLayer />
            </StageCanvas>
            <ToastRail />
            <StoryFlashOverlay />
            <MasteryCutsceneOverlay />
            <SituationDrawer />
            <OrientationGuard />
            {/* 히든 치트 진입점 — 어디서든 "qqwweerr" 타이핑. */}
            <CheatGate />
        </>
    );
}
